import React, { forwardRef } from "react";
import { LinkButton as SpectrumLinkButton } from "@react-spectrum/s2";
import { s2UnslottedLabel } from "./s2UnslottedLabel";

type LinkButtonProps = React.ComponentProps<typeof SpectrumLinkButton>;

export const LinkButton = forwardRef<
  React.ElementRef<typeof SpectrumLinkButton>,
  LinkButtonProps
>((props, ref) => {
  const { children, ...rest } = props;
  const inner =
    typeof children === "string" || typeof children === "number"
      ? children
      : s2UnslottedLabel(children);
  return (
    <SpectrumLinkButton ref={ref} {...rest}>
      {inner}
    </SpectrumLinkButton>
  );
});

LinkButton.displayName = "LinkButton";
